import { findTeamById, TeamWithSubTeams } from '../../../screens/Teams/SupervisorTeamSelect';

export const SELECT_ALL_ID = 'select-all';

const getAllSubTeamIds = (team: TeamWithSubTeams): string[] => {
  let ids: string[] = [];
  if (team.subTeams) {
    team.subTeams.forEach((subTeam) => {
      ids.push(subTeam.id);
      ids = ids.concat(getAllSubTeamIds(subTeam));
    });
  }
  return ids;
};

const getAllTeamIdsInStructure = (teams: TeamWithSubTeams[]): string[] => {
  let ids: string[] = [];
  teams.forEach((team) => {
    ids.push(team.id);
    ids = ids.concat(getAllTeamIdsInStructure(team.subTeams));
  });
  return ids;
};

const isSubTeamOfAny = (teamId: string, parentTeamIds: string[], teams: TeamWithSubTeams[]): boolean => {
  for (const parentId of parentTeamIds) {
    const parentTeam = findTeamById(teams, parentId);
    if (parentTeam) {
      const subTeamIds = getAllSubTeamIds(parentTeam);
      if (subTeamIds.includes(teamId)) {
        return true;
      }
    }
  }
  return false;
};

export const getRootTeamsOnly = (teamIds: string[], allTeams: TeamWithSubTeams[]): string[] => {
  if (!teamIds) return [];

  if (teamIds.length === 1 && teamIds[0] === SELECT_ALL_ID) {
    return getAllTeamIdsInStructure(allTeams);
  }

  return teamIds.filter(
    (id) =>
      !isSubTeamOfAny(
        id,
        teamIds.filter((pid) => pid !== id),
        allTeams,
      ),
  );
};

export const getDisabledSubTeams = (teamIds: string[], allTeams: TeamWithSubTeams[]): string[] => {
  if (!teamIds) return [];

  const roots = getRootTeamsOnly(teamIds, allTeams);
  let disabledIds: string[] = [];

  roots.forEach((rootId) => {
    const rootTeam = findTeamById(allTeams, rootId);
    if (rootTeam) {
      disabledIds = disabledIds.concat(getAllSubTeamIds(rootTeam));
    }
  });

  return disabledIds;
};
